import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { xor } from 'lodash';
import { RATINGS } from '../../../../lib/schema.js';
import RatingLabel from '../../../RatingLabel.jsx';

StakeholderFrequencyFilter.defaultProps = {
  selectedStakeholderFrequencies: [],
};

function StakeholderFrequencyFilter({
  selectedStakeholderFrequencies,
  navigateAction,
}) {
  const selectedCount = selectedStakeholderFrequencies.length;
  const handleSelect = useCallback(
    (stakeholderFrequency) =>
      navigateAction({
        stakeholderEngagementFrequencies: stakeholderFrequency
          ? xor(selectedStakeholderFrequencies, [stakeholderFrequency])
          : [],
      }),
    [selectedStakeholderFrequencies]
  );

  const renderMenuItem = useCallback(
    (stakeholderFrequency) => (
      <React.Fragment key={stakeholderFrequency}>
        <MenuItem
          active={selectedStakeholderFrequencies.includes(stakeholderFrequency)}
          eventKey={stakeholderFrequency}
          onSelect={handleSelect}
        >
          <RatingLabel rating={stakeholderFrequency} />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedStakeholderFrequencies]
  );
  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        Stakeholder Engagement Frequency
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="stakeholder-frequency-filter"
          className="btn-block text-capitalize"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>

          <MenuItem divider />
          {RATINGS.FREQUENCY_LEVELS.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default StakeholderFrequencyFilter;
